import React, { useEffect, useState } from "react";
import { SubTitle } from "./index.styled";

const countUp = (finalValue, duration, setCount) => {
  let start = 0;
  const increment = finalValue / (duration / 16);

  const updateCounter = () => {
    start += increment;
    if (start >= finalValue) {
      setCount(finalValue);
    } else {
      setCount(Math.floor(start));
      requestAnimationFrame(updateCounter);
    }
  };

  requestAnimationFrame(updateCounter);
};

const AnimatedCounter = ({ target, color, duration = 400 }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    countUp(target, duration, setCount);
  }, [target, duration]);

  return <SubTitle color={color}>{count}</SubTitle>;
};

export default AnimatedCounter;
